module.exports = __webpack_public_path__ + "img/weixinkefu.472cfabe.png";